export default function CountPill({ product }){
    if (!product.count) {
        return null;
    }

    return (
        <div className='product-card__pill'>
            <span className="count-pill">{product.count}</span>
        </div>
    );
}
